import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getCategories   = (params, token) => Axios.get("/api/v1/admin/blog/categories", { params, ...h(token) });
export const getCategoryById = (id, token)     => Axios.get(`/api/v1/admin/blog/categories/${id}`, h(token));
export const createCategory  = (data, token)   => Axios.post("/api/v1/admin/blog/categories", data, h(token));
export const updateCategory  = (id, data, tok) => Axios.put(`/api/v1/admin/blog/categories/${id}`, data, h(tok));
export const deleteCategory  = (id, token)     => Axios.delete(`/api/v1/admin/blog/categories/${id}`, h(token));
